const React = require('react');
const {paramStore} = require('../../../../../../stores');
const withState = require('../../../../../../utils/withState');
const Ripple = require('../../../../Ripple');
const {AdminTitle} = require('../../../AdminLayout/');
const noop = require("mn-utils/noop");

const USER_REG_LIST = [
  {
    id: 'company',
    title: 'Company'
  },
  {
    id: 'personalProfile',
    title: 'Personal Profile'
  },
  {
    id: 'businessOwners',
    title: 'Business Owners'
  },
  {
    id: 'activationScreen',
    title: 'Activate Retailer'
  },
  // {
  //   id: 'supportingDocuments',
  //   title: 'Supporting Documents'
  // },
  // {
  //   id: 'bankDetails',
  //   title: 'Bank Details'
  // }
];

const initialStep = USER_REG_LIST[0].id;
const regStep$ = paramStore('regStep', initialStep);
const newUserId$ = paramStore('userId', '');

const Menu = ({stepsRequired, stepsCompleted, stepsDisabled, activeStep, emit, disableFlow}) => {
  return (
    <div className="layoutRow fxwWrap aiC mt-10">
      {USER_REG_LIST.map(({id, title}) => {
        const isRequired = (stepsRequired || []).includes(id);
        const isCompleted = stepsCompleted[id];
        const isDisabled = stepsDisabled[id];

        return (
          <div key={id} className="mr8">
            <Ripple
              className={
                `h26 layoutRow aiC jcC mt10 ph10 pb2 f12 lh18 r13
              c0 bgF b1 bs bcDCDCDC
              (cF|bg3E4044|bc3E4044).active
              o50.disabled`
                + (id === activeStep ? ' active' : '')
                + (isDisabled ? ' disabled' : '')
                + (isCompleted ? ' completed' : '')
              }
              onClick={() => emit(id)}
              disabled={isDisabled}
            >
              <span>{title}{isRequired && !isCompleted ? ' *' : ''}</span>
              {!!isCompleted && (
                <svg className="ml4" width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.45208 0L3.75 4.87032L1.5475 2.76042L0 4.32505L3.75 8L10 1.56421L8.45208 0Z" fill="#2CE889"/>
                </svg>
              )}
            </Ripple>
          </div>
        )
      })}
    </div>
  )
}

module.exports = withState((setState, self, onMount) => {

  const DEFAULT_DISABLED_STEPS = {
    company: true,
    personalProfile: true,
    businessOwners: true,
    supportingDocuments: true,
    activationScreen: true,
  }

  const resetUserData = () => {
    const getterFN = self.props.newUserDataGetter;

    if (!getterFN) return;

    const id = self.state.newUserId;

    return getterFN({id, with_docs: true, with_profile: true, with_owners: true})
        .then((res) => {
          const stepsCompleted = {};
          const stepsDisabled = {};

          const stepsChecksCompeted = {
            company: (data) => (data.company || {}).reg_number,
            personalProfile: (data) => ((data.company || {}).profiles || []).length,
            businessOwners: (data) => ((data.company || {}).owners || []).length,
          }

          const stepsRequired = ['company', 'personalProfile'];

          const stepsChecksDisabled = {
            personalProfile: (data) => !(data.company || {}).reg_number,
            businessOwners: (data) => !((data.company || {}).profiles || []).length,
            activationScreen: (data) => !((data.company || {}).profiles || []).length
          }

          Object.keys(stepsChecksCompeted).forEach((key) => {
            const fn = stepsChecksCompeted[key] || noop;
            stepsCompleted[key] = fn(res)
          });

          Object.keys(stepsChecksDisabled).forEach((key) => {
            const fn = stepsChecksDisabled[key] || noop;
            stepsDisabled[key] = fn(res)
          });

          setState({stepsData: res, stepsRequired, stepsCompleted, stepsDisabled});
        })
        .finally(() => setState({loading: false}));
  }

  onMount(() => {
    const id = self.state.newUserId;

    if (!id) return;

    setState({loading: true});
    resetUserData();
  })

  return (state, props) => {
    const {title, views = {}} = props;
    const activeStep = state.regStep;
    const activeUserId = state.newUserId;
    const stepsData = state.stepsData || {};
    const stepsRequired = state.stepsRequired || [];
    const stepsCompleted = state.stepsCompleted || {};
    const stepsDisabled = state.stepsDisabled || DEFAULT_DISABLED_STEPS;
    const View = state.loading ? '' : views[activeStep];
    const currentStep = USER_REG_LIST.findIndex(({id}) => id === activeStep) || 0;
    const nextStepIndex = Number(currentStep) + 1;
    const nextStepId = (USER_REG_LIST[nextStepIndex] || {}).id;

    const emitNextStep = () => {
      regStep$.emit(nextStepId);

      const contentBlock = document.getElementsByClassName('admin-content')[0];
      if (contentBlock && contentBlock.scrollTo) contentBlock.scrollTo(0, 0);
    };
    const onFormResult = () => resetUserData().then(emitNextStep);
    const emitNewUserId = (id) => newUserId$.emit(id);

    return (
      <>
        <div className="layoutRow aiC dB@m2">
          <div className="mr26">
            <AdminTitle text={title} />
          </div>
          <div className="mt20@m2">
            <Menu
              stepsRequired={stepsRequired}
              stepsCompleted={stepsCompleted}
              stepsDisabled={stepsDisabled}
              activeStep={state.regStep}
              emit={regStep$.emit}
            />
          </div>
        </div>
        {View && (
          <div className="mt30">
            <View
              activeUserId={activeUserId}
              stepsData={stepsData}
              stepsCompleted={stepsCompleted}
              resetUserData={resetUserData}
              emitNewUser={emitNewUserId}
              onFormResult={onFormResult}
              // change to btn props or something like that
              onNextStep={emitNextStep}
              nextStepDisabled={stepsDisabled[nextStepId]}
            />
          </div>
        )}
      </>
    )
  }
}, {
  regStep: regStep$,
  newUserId: newUserId$
})
